<div class="wrapper wrapper-content mtv-parcels-page row">
    <div class="ibox mainPartPage"
         [class.showDetailedView]="amenitiesService.showDetailedView"
         [ngStyle]="{width: amenitiesService.showDetailedView ? 'calc(100% - 420px)' : '100%'}">
        <div class="ibox-content no-scroll-mode" [ngClass]="{'calendar-view' : amenitiesService.view == 'calendar'}">
            <div class="row">
                <div class="col-sm-7">
                    <filter [tabHeading]="'Amenities'" [buildings]="amenitiesService.buildingsForRead"></filter>
                </div>

                <amenities-filter (onAmenitiesChange)="onAmenitiesChange($event)"></amenities-filter>
                <div
                    *ngIf="amenitiesService.canEdit() && (!authenticationService.userIsResident || (authenticationService.userIsResident && amenitiesService.amenitiesByBuilding.length > 0))"
                    class="col-sm-3">
                    <button type="button" class="btn btn-w-m btn-primary pull-right"
                            (click)="newBooking()"
                            [disabled]="!(amenitiesService.buildings.length || residentService.buildings.length)">
                        <i class="fa fa-plus-circle"></i> New Booking
                    </button>
                </div>

            </div>
            <div class="row">
                <div class="col-sm-12">
                    <filters-view [itemData]="amenitiesData"></filters-view>
                </div>
            </div>
            <div class="row m-t-sm m-r-sm text-right">
                <div class="pull-right col-sm-6" style="width: 220px; float: right;">
                    <div *ngIf="amenitiesService.view != 'list'"
                         (click)="changeView('list')"
                         class="clickable mtv-primary-color m-r-lg">
                        <i class="fa fa-bars" aria-hidden="true"></i>
                        List View
                    </div>
                    <div *ngIf="amenitiesService.view != 'calendar'"
                         (click)="changeView('calendar')"
                         class="clickable mtv-primary-color m-r-sm">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        Calendar View
                    </div>
                </div>
            </div>
            <tabs-wrapper>
                <tab-item [tabId]="'allAmenities'" [ngClass]="{'sk-loading': amenitiesService.spinnerShow}">
                    <amenities-list *ngIf="amenitiesService.view == 'list'"></amenities-list>
                    <amenities-calendar-view *ngIf="amenitiesService.view == 'calendar'"></amenities-calendar-view>
                </tab-item>
                <pagination *ngIf="amenitiesService.data.allAmenities.total && urlService.queryParams['page']"
                            [total]="amenitiesService.data['allAmenities'].total"></pagination>
                <spinner [spinnerShow]="amenitiesService.spinnerShow && amenitiesService.view == 'list'"></spinner>
                <spinner
                    [spinnerShow]="amenitiesService.calendarSpinnerShow && amenitiesService.view == 'calendar'"></spinner>
            </tabs-wrapper>
        </div>
    </div>
    <div class="animated animated-directory slideInRight detailed-view dv-sidebar">
        <amenities-detailed-view *ngIf="amenitiesService.showDetailedView"></amenities-detailed-view>
    </div>
</div>

<amenities-modal *ngIf="amenitiesService.isAmenityModalShow"></amenities-modal>
<amenities-view *ngIf="amenitiesService.isAmenityViewShow"></amenities-view>
<disabled-date-modal *ngIf="amenitiesService.isDisabledDateModalShown"></disabled-date-modal>
<amenity-payment-modal *ngIf="amenitiesService.isAmenityPaymentShow"></amenity-payment-modal>
<amenity-deposit-charge *ngIf="amenitiesService.isAmenityDepositChargeShow"></amenity-deposit-charge>
<amenities-quotes-modal *ngIf="amenitiesService.showQuoteModal"></amenities-quotes-modal>



// WEBPACK FOOTER //
// /app/src/app/views/amenities/amenities.component.html